import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./roots";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./rootSaga";

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const configureAppStore = () => {
  const appRootReducer = rootReducer();
  const store = configureStore({
    reducer: appRootReducer,
    middleware: middlewares,
    devTools: process.env.NODE_ENV === "development",
  });
  sagaMiddleware.run(rootSaga);
  return { store };
};

export default configureAppStore;
